var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_9852)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F19711"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1416_9852",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2475 18.3639L27.2475 13.516C27.2475 11.233 25.4377 9.38452 23.2023 9.38452H14.6154C12.3801 9.38452 10.5702 11.233 10.5702 13.516V26.4236C10.5702 28.7066 12.3801 30.5551 14.6154 30.5551H23.9284"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2475 18.3639L27.2475 13.516C27.2475 11.233 25.4377 9.38452 23.2023 9.38452H14.6154C12.3801 9.38452 10.5702 11.233 10.5702 13.516V26.4236C10.5702 28.7066 12.3801 30.5551 14.6154 30.5551H23.9284",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2475 13.516L29.2475 13.516V13.516H27.2475ZM29.2475 18.3639L29.2475 13.516L25.2475 13.516L25.2475 18.3639L29.2475 18.3639ZM29.2475 13.516C29.2475 10.1684 26.5818 7.38452 23.2023 7.38452V11.3845C24.2935 11.3845 25.2475 12.2976 25.2475 13.516H29.2475ZM23.2023 7.38452H14.6154V11.3845H23.2023V7.38452ZM14.6154 7.38452C11.2359 7.38452 8.57019 10.1684 8.57019 13.516H12.5702C12.5702 12.2976 13.5242 11.3845 14.6154 11.3845V7.38452ZM8.57019 13.516V26.4236H12.5702V13.516H8.57019ZM8.57019 26.4236C8.57019 29.7712 11.2359 32.5551 14.6154 32.5551V28.5551C13.5242 28.5551 12.5702 27.642 12.5702 26.4236H8.57019ZM14.6154 32.5551H23.9284V28.5551H14.6154V32.5551Z",
    fill: "white",
    mask: "url(#path-2-inside-1_1416_9852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8041 24.4149C30.8041 27.4141 28.3728 29.8455 25.3736 29.8455C22.3744 29.8455 19.9431 27.4141 19.9431 24.4149C19.9431 21.4157 22.3744 18.9844 25.3736 18.9844C28.3728 18.9844 30.8041 21.4157 30.8041 24.4149Z",
    fill: "white",
    stroke: "#F19711",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7709 14.6038H22.4813",
    stroke: "#F19711",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7709 17.9565H19.5899",
    stroke: "#F19711",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7709 21.3098H17.6623",
    stroke: "#F19711",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.94 24.9551L27.2476 24.9551",
    stroke: "#F19711",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.94 24.9551L24.94 22.2048",
    stroke: "#F19711",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_9852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOrders);
export default __webpack_public_path__ + "static/media/profile-orders.9cb9cd7586c893578982a3bd028203f7.svg";
export { ForwardRef as ReactComponent };